import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');
//require('wowjs');

const WOW = require('wowjs');

window.wow = new WOW.WOW({
  // boxClass: 'image', // boxClass: 'wow', // default
  // live: false
});

//https://github.com/foundation/motion-ui/blob/master/docs/wow.md
// wow = new WOW(
// {
// boxClass: 'wow', // default
// animateClass: 'animated', // default
// offset: 0 // default
// }
// )
// WOW.init();

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

window.wow.init();


// from https://coolcssanimation.com/how-to-trigger-a-css-animation-on-scroll/
// Remove the transition class
//const animate = document.querySelector('.animate');
//animate.classList.remove('animated');
const animate = document.querySelectorAll('.animate');
for (var i = 0; i < animate.length; i++) {
  animate[i].classList.remove('animated');
}

// Create the observer, same as before:
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      console.log(entry);
      //animate.classList.add('animated');
      entry.target.classList.add('animated');
      return;
    }

    //animate.classList.remove('animated');
    entry.target.classList.remove('animated');
  });
});

const animateIds = ['#animate-body','#animate-content','#animate-download','#animate1','#animate2','#animate3'];
for (var i = 0; i < animateIds.length; i++) {
  if($(animateIds[i]).length){
    observer.observe(document.querySelector(animateIds[i]));
  }
}

// observer.observe(document.querySelector('#animate-body'));
// //observer.observe(document.querySelector('#animate0'));
// observer.observe(document.querySelector('#animate1'));
// observer.observe(document.querySelector('#animate2'));
// observer.observe(document.querySelector('#animate3'));
